{
    "stats_block_title__recommendation_count": "Anzahl Abwanderungswarnungen",
    "stats_block_title__customer_count": "Kunden mit Abwanderungswarnungen",
    "stats_block_title__total_loss": "Potenzielle Umsatzabwanderung",
    "state_block_detail__vs_last_period": "zur Vorperiode",

    "note_body": "Wenn du eine Aufgabe für eine Vertriebsempfehlung erstellst verschwindet diese aus dieser Ansicht",

    "insight_table__header_insight_generated_at": "Berechnet",
    "insight_table__header_customer": "Kunde",
    "insight_table__header_product_group": "Produktgruppe",
    "insight_table__header_ttm_delta": "Umsatzabweichung letzte 12M",
    "insight_table__header_sales_last_24_months": "Umsatz letzte 24 Monate",
    "insight_table__header_orders_last_24_months": "Aufträge letzte 24 Monate",
    "insight_table__header_reason": "Begründung",
    "insight_table__header_sales_rep": "Vertreter",

    "search_placeholder__customers": "Suche nach Kunden"
}
